// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__KYZwb","children":"style_children__1eY_D"};